<template>
    <DefaultHeader />
    <section :class="{ 'd-none': this.$store.state.hiddenBody }" class="container d-flex flex-column">
        <div class="row mb-2">
            <div class="col-12 col-md-6">

                <MainBaliseInfo :baliseInfo="this.baliseInfo" :groups="this.groups" @refresh="refreshData"
                    @changeBalise="changeBalise" @setBaliseToUpdate="setBaliseToUpdate" />

                <!-- Map car icon -->
                <VehicleMapIcon :balise="baliseInfo" class="d-none d-lg-block" />

            </div>

            <div class="col-12 col-md-6 d-flex flex-column">
                <div class="row mb-3">
                    <PositionShareCard v-if="baliseInfo.id && ($isOperator || $isAdmin)" :balise="baliseInfo" />
                </div>

                <div class="row mb-3">
                    <SuperAdmin v-if="baliseInfo.id && $isAdmin" @refresh="this.refreshData()" :balise="baliseInfo" />
                </div>
                <div class="row mb-3">
                    <BaliseButtonsCard v-if="baliseInfo.id && $isAdmin" :buttons="baliseButtons" :balise="baliseInfo" />
                </div>
                <div class="row">
                    <CorridoringControl v-if="baliseInfo.id && baliseInfo.featureCorridoring"
                        @refresh="this.refreshData()" :balise="baliseInfo" />
                </div>
                <div class="row mt-3">
                    <DrivesAlarmsPositions :drives="baliseDrives" :alarms="baliseAlerts" :positions="balisePings" />
                </div>
                <div class="row mt-3">
                    <div class="col">
                        <VehicleReportCard v-if="baliseInfo.id" :balise-id="baliseInfo.id" />
                    </div>
                </div>
                <div class="row mt-3">
                    <HistoryDatepicker :balise="baliseInfo" />
                </div>
            </div>

        </div>

        <div v-if="[1, 2, 4].includes(baliseInfo.commercialPackageId)" class="row mt-2">
            <div class="col">
                <NotificationParam :balise="baliseInfo" />
            </div>
        </div>

    </section>
    <IconPickerModal :baliseToUpdate="baliseToUpdate" />
    <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/DefaultHeader.vue'
import DefaultFooter from '@/components/DefaultFooter.vue'
import BaliseRepository from '@/repositories/balise.repo.js'
import FormatHelper from '@/helpers/format.helper.js'
import PositionService from '@/services/position.service'
import DriveService from '@/services/drive.service'
import AlarmService from '@/services/alarm.service'
import IconPickerModal from '@/components/balisesPage/IconPickerModal.vue'
import Group from '@/services/group.service'
import DrivesAlarmsPositions from './Sections/DrivesAlarmsPositions.vue'
import CorridoringControl from './Sections/CorridoringControl.vue'
import SuperAdmin from './Sections/SuperAdmin.vue'
import VehicleMapIcon from './Sections/VehicleMapIcon.vue'
import MainBaliseInfo from './Sections/MainBaliseInfo.vue'
import NotificationParam from './Sections/NotificationParam.vue'
import HistoryDatepicker from './Sections/HistoryDatepicker.vue'
import VehicleReportCard from './Sections/VehicleReportCard.vue'
import CmdService from '@/services/cmd.service'
import BaliseButtonsCard from './Sections/BaliseButtonsCard.vue'
import PositionShareCard from './Sections/PositionShareCard.vue'

export default {
    components: {
        DefaultHeader,
        DefaultFooter,
        IconPickerModal,
        DrivesAlarmsPositions,
        CorridoringControl,
        VehicleMapIcon,
        MainBaliseInfo,
        NotificationParam,
        HistoryDatepicker,
        SuperAdmin,
        VehicleReportCard,
        BaliseButtonsCard,
        PositionShareCard
    },
    data() {
        return {
            baliseInfo: {},
            balisePings: [],
            baliseDrives: [],
            baliseAlerts: [],
            baliseToUpdate: null,
            groups: [],
            lock: true,
            baliseButtons: [],
        };
    },
    mounted() {
        this.refreshData();
        this.baliseLastsPings();
        this.baliseLastsDrives();
        this.baliseLastsAlerts();
        this.getAllGroups();
        this.loadBaliseButtons();
    },
    methods: {

        /************************************************/
        /**** START DISPLAYED INFO LOADING FUNCTIONS ****/
        /************************************************/

        // Get the balise data
        refreshData() {
            BaliseRepository.getBalise(this.$route.params.id)
                .then(balise => {
                    this.baliseInfo = balise;
                })
                .catch(e => {
                    console.log(e);
                });
        },
        // Get the 3 last positions to be displayed in the positions area
        baliseLastsPings() {
            PositionService.getBalisePositions(this.$route.params.id, 0, 3)
                .then(response => {
                    this.balisePings = FormatHelper.balisePingsFormat(response.data)
                })
        },
        // Get the 3 last drives to be displayed in the drives area
        baliseLastsDrives() {
            DriveService.getBaliseDrives(this.$route.params.id, 0, 3)
                .then(response => {
                    this.baliseDrives = FormatHelper.baliseDrivesFormat(response.data.rows)
                })
        },
        // Get the 3 last alerts to be displayed in the alerts area
        baliseLastsAlerts() {
            AlarmService.getBaliseAlarms(this.$route.params.id, 0, 3)
                .then(response => {
                    this.baliseAlerts = FormatHelper.baliseAlertsFormat(response.data.rows)
                })
        },

        /**********************************************/
        /**** END DISPLAYED INFO LOADING FUNCTIONS ****/
        /**********************************************/

        setBaliseToUpdate(param) {
            this.baliseToUpdate = param;
        },
        changeBalise(bId) {
            this.$emit("param", bId);
        },
        getAllGroups() {
            Group.getClientGroups().then(groups => {
                for (let group in groups.data) {
                    this.groups.push([groups.data[group].name, groups.data[group]])
                }
            })
        },
        loadBaliseButtons() {
            if (!this.$route.params.id) return;
            CmdService.getButtons(this.$route.params.id)
                .then(response => {
                    // on suppose que l'API renvoie un tableau direct
                    this.baliseButtons = Array.isArray(response.data) ? response.data : [];
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
}
</script>

<style>
.map_background {
    background-image: url('@/assets/Img_carte.png');
}

.pointer-cursor:hover {
    cursor: pointer;
}

@media (min-width: 768px) {
    .h-md-auto {
        height: auto !important;
    }
}
</style>
